module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQAgMAAABvg2e1AAAAAXNSR0IB2cksfwAAAAxQTFRFAAAAAAAAAAAAAAAANek3lgAAAAR0Uk5TAMD/v+rGo7UAAAAlSURBVHicY8hatWrVBgYGEDWBgRgAUgnUAaaI0pG1ajWEWgkkATpDEPEtPiybAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/content-view--header--toggle-menu.png
// module id = 803
// module chunks = 0